<template>
    <aside :class="['ref020-sidebar', { 'ref020-sidebar-collapsed': innerCollapsed }]">
        <!-- 손잡이 bar (사이드바 안 absolute, 우측 가장자리 전체 세로) + 화살표 + 세로 텍스트 (viewport 세로 중앙) -->
        <!-- hot-fix #20 안건 5 (2026-05-07): 한글 "열기" / "닫기" + 화살표 (사용자 결정) — 의미 강화 -->
        <!-- hot-fix #20 안건 20 (2026-05-08): 핸들은 outer aside 안 absolute 그대로 — inner scroll wrapper 밖에 위치. 핸들 고정 + 메뉴 영역만 스크롤 (사용자 결정) -->
        <button type="button"
                class="ref020-sidebar-toggle"
                @click="onToggle"
                :title="innerCollapsed ? '사이드바 펼치기' : '사이드바 접기'">
            <span class="ref020-sidebar-toggle-indicator">
                <span class="ref020-sidebar-toggle-text">{{ innerCollapsed ? 'OPEN' : 'CLOSE' }}</span>
                <span class="ref020-sidebar-toggle-arrow">{{ innerCollapsed ? '▶' : '◀' }}</span>
            </span>
        </button>

        <!-- hot-fix #20 안건 20 (2026-05-08): inner scroll wrapper — 핸들 좌측 (메뉴 영역) 만 스크롤. 스크롤바가 핸들 영역 안쪽에 생김 (사용자 결정) -->
        <div class="ref020-sidebar-scroll">
        <!-- 브랜드 (REF-020 hot-fix #20 안건 3 — full-height sidebar 구조 채택, 브랜드는 사이드바 좌상 drawer 표준) -->
        <a class="ref020-sidebar-brand" href="/" title="GONELO B2B Global Logistics Partner">
            <i class="ref020-sidebar-brand-icon">✈</i>
            <span class="ref020-sidebar-brand-name">GONELO</span>
        </a>

        <!-- (c) 관리 컨텍스트 카드 (관리자 + 회원사 라우팅 시) -->
        <!-- REF-020 hot-fix #20 안건 37 (2026-05-08): 디자인 개선 — 회원사명 헤더 + 아이콘 정보 행 + 예치금·미결제 클릭 링크. -->
        <div v-if="adminContextCard" class="ref020-sidebar-admin-card">
            <!-- hot-fix #20 안건 91 후속 (2026-05-18 / 사용자 결정 — 라벨 위치 닉네임 하위 서브정보 + 아이콘 통일):
                 person 아이콘 → home 아이콘 (헤딩 컴포넌트와 통일).
                 출고제한 = 닉네임 하위 sub-row (block 아이콘 + 빨강 텍스트, 배경 없이 명료). -->
            <div class="ref020-admin-card-header">
                <i class="material-icons">home</i>
                <span class="ref020-admin-card-nick">{{ adminContextCard.nick }}</span>
            </div>
            <div v-if="adminContextCard.restrict_shipout"
                 class="ref020-admin-card-sub ref020-restrict-shipout-label"
                 uk-tooltip="title: 미결제 등의 사유로 출고제한 되었습니다.; pos: top">
                <i class="material-icons">block</i>출고제한
            </div>
            <div v-if="adminContextCard.restrict_register"
                 class="ref020-admin-card-sub ref020-restrict-shipout-label"
                 uk-tooltip="title: 미결제 등의 사유로 배송등록제한 되었습니다.; pos: top">
                <i class="material-icons">block</i>등록제한
            </div>
            <div class="ref020-admin-card-rows">
                <div v-if="adminContextCard.mailbox" class="ref020-admin-card-row"
                     :title="'내 사서함: ' + adminContextCard.mailbox">
                    <i class="material-icons">mail</i>
                    <span class="ref020-admin-card-label">사서함</span>
                    <span class="ref020-admin-card-value">{{ adminContextCard.mailbox }}</span>
                </div>
                <!-- 안건 91 후속 3 (2026-05-18 사용자 결정): 예치금 색상 강조 제거 (cardDepositClass 폐기).
                     강조 대상은 미결제만 — 예치금 잔액은 일반 텍스트로 노출 (인지 부담 감소). -->
                <a class="ref020-admin-card-row ref020-admin-card-link"
                   :href="adminContextCard.deposit_url"
                   :title="'예치금 ₩' + formatNumber(adminContextCard.deposit) + ' — 입금확인요청'">
                    <i class="material-icons">account_balance_wallet</i>
                    <span class="ref020-admin-card-label">예치금</span>
                    <span class="ref020-admin-card-value">₩{{ formatNumber(adminContextCard.deposit) }}</span>
                </a>
                <a v-if="adminContextCard.arrears_count > 0"
                   class="ref020-admin-card-row ref020-admin-card-link ref020-admin-card-arrears"
                   :href="adminContextCard.arrears_url"
                   :title="'미결제 ' + adminContextCard.arrears_count + '건 / ₩' + formatNumber(adminContextCard.arrears_amount) + ' — 미결제건 조회'">
                    <i class="material-icons">warning</i>
                    <span class="ref020-admin-card-label">미결제</span>
                    <span class="ref020-admin-card-value">{{ adminContextCard.arrears_count }}건 / ₩{{ formatNumber(adminContextCard.arrears_amount) }}</span>
                </a>
            </div>
        </div>

        <!-- hot-fix #20 안건 13 (2026-05-07): 센터 표시 (큰 폰트 + 국기) — 회원사 카드 아래, 라우팅 라벨 위.
             안건 77 (2026-05-12): centerUrl 존재 시 클릭 가능 anchor — 컨텍스트별 종합현황 진입점.
             안건 79 (2026-05-14): 회원사 컨텍스트 + page_region_id 없음 (전체센터) 시 centerIcon (material public) 으로 국기 대체. -->
        <a v-if="centerLabel && centerUrl"
           :href="centerUrl"
           :title="centerLabel + ' — 종합현황 진입'"
           class="ref020-sidebar-center ref020-sidebar-center-link">
            <img v-if="centerFlag" :src="centerFlag" :alt="centerLabel" class="ref020-sidebar-center-flag" />
            <i v-else-if="centerIcon" class="material-icons ref020-sidebar-center-icon" :aria-label="centerLabel">{{ centerIcon }}</i>
            <span class="ref020-sidebar-center-label">{{ centerLabel }}</span>
        </a>
        <div v-else-if="centerLabel" class="ref020-sidebar-center">
            <img v-if="centerFlag" :src="centerFlag" :alt="centerLabel" class="ref020-sidebar-center-flag" />
            <i v-else-if="centerIcon" class="material-icons ref020-sidebar-center-icon" :aria-label="centerLabel">{{ centerIcon }}</i>
            <span class="ref020-sidebar-center-label">{{ centerLabel }}</span>
        </div>

        <!-- 라우팅 컨텍스트 라벨 (텍스트만, 클릭 동작 없음) -->
        <div v-if="routingLabel" class="ref020-sidebar-context-label">{{ routingLabel }}</div>

        <!-- 메인 메뉴 (라우팅별, 펼침 + collapsible sub-item).
             안건 67 (2026-05-12): mainMenu 비었을 때 (e.g. /home/* 로그인 시 — 안건 65) ul/divider 모두 미노출 →
             brand border-bottom + hr divider 가 컨텐츠 없이 연속되어 두 선처럼 보이는 문제 해소. -->
        <ul v-if="mainMenu && mainMenu.length > 0" class="ref020-sidebar-menu">
            <li v-for="(item, index) in mainMenu"
                :key="'main-' + index"
                :class="['ref020-sidebar-menu-item', { 'has-sub': item.subs && item.subs.length > 0, active: item.active, primary: item.primary, expanded: expandedIndex === index }]">
                <a v-if="!item.subs || item.subs.length === 0"
                   :href="item.url"
                   :target="item.target"
                   :title="item.name"
                   class="ref020-sidebar-link">
                    <i v-if="item.icon && item.iconType === 'material'" class="material-icons">{{ item.icon }}</i>
                    <img v-else-if="item.icon && item.iconType === 'img'" :src="item.icon" :alt="item.name" />
                    <span class="ref020-sidebar-link-name">{{ item.name }}</span>
                    <span v-if="item.countBadge > 0" class="ref020-sidebar-badge">{{ item.countBadge }}</span>
                </a>
                <template v-else>
                    <button type="button" class="ref020-sidebar-link ref020-sidebar-parent" :title="item.name" @click="toggleExpand(index)">
                        <i v-if="item.icon && item.iconType === 'material'" class="material-icons">{{ item.icon }}</i>
                        <img v-else-if="item.icon && item.iconType === 'img'" :src="item.icon" :alt="item.name" />
                        <span class="ref020-sidebar-link-name">{{ item.name }}</span>
                        <span v-if="item.countBadge > 0" class="ref020-sidebar-badge">{{ item.countBadge }}</span>
                        <!-- 안건 59 (2026-05-12): 서브메뉴 토글 화살표 — 유니코드 ▾/▸ → Material Icons (가독성 ↑) -->
                        <i class="material-icons ref020-sidebar-arrow">{{ expandedIndex === index ? 'expand_more' : 'chevron_right' }}</i>
                    </button>
                    <ul v-show="expandedIndex === index" class="ref020-sidebar-submenu">
                        <li v-for="(sub, subIndex) in item.subs"
                            :key="'sub-' + index + '-' + subIndex"
                            :class="['ref020-sidebar-submenu-item', { active: sub.active }]">
                            <a :href="sub.url" :target="sub.target" :title="sub.name" class="ref020-sidebar-sublink">
                                <!-- 안건 62 (2026-05-12): 서브항목 indent 시각 단서 — bullet (방향성 없는 중성 marker) -->
                                <span class="ref020-sidebar-sub-prefix">•</span>
                                <span class="ref020-sidebar-link-name">{{ sub.name }}</span>
                                <span v-if="sub.countBadge > 0" class="ref020-sidebar-badge">{{ sub.countBadge }}</span>
                            </a>
                        </li>
                    </ul>
                </template>
            </li>
        </ul>

        <hr v-if="mainMenu && mainMenu.length > 0" class="ref020-sidebar-divider" />

        <!-- 공통 메뉴 (HOME / 공지 / FAQ / 내 정보 / 도구) -->
        <ul class="ref020-sidebar-menu ref020-sidebar-common">
            <li v-for="(item, index) in commonMenu"
                :key="'common-' + index"
                class="ref020-sidebar-menu-item">
                <a :href="item.url" :target="item.target" :title="item.name" class="ref020-sidebar-link">
                    <i v-if="item.icon && item.iconType === 'material'" class="material-icons">{{ item.icon }}</i>
                    <span class="ref020-sidebar-link-name">{{ item.name }}</span>
                </a>
            </li>
        </ul>

        </div><!-- /.ref020-sidebar-scroll (안건 63 — padding-bottom 으로 가로 스크롤바 buffer) -->
    </aside>
</template>

<script>
// REF-020 Phase 2-C (2026-05-04) — 신규 사이드바 SSOT Vue 컴포넌트 (M3 δ 네 번째)
//
// 결정 12 — (c) 관리 카드 (관리자 + 회원사 라우팅 시) → 라우팅 컨텍스트 라벨 → 메인 메뉴 → 공통 메뉴
// 결정 13 — 메뉴 컨텍스트 = 라우팅 결정. 사이드바 접기 cookie/localStorage 저장
// 결정 16 — 모듈 드롭다운 폐지. 사이드바 = 라우팅 라벨 + 메인메뉴 + 공통메뉴
// 결정 17 — 사이드바 우상 ◀ 접기 (헤더 ☰ 햄버거와 단일 토글)
// 결정 22 critical — adminContextCard 가 회원사 본인 진입 시 null 보장 (server-side MenuResolve 가드)
//
// props:
//   adminContextCard (Object|null) — { nick, mailbox, deposit, arrears_count, arrears_amount }
//   routingLabel (String|null)     — 라우팅 컨텍스트 라벨 ("회원사 메뉴" / "창고 메뉴" / "총괄 관리" / "시스템")
//   mainMenu (Array)               — 라우팅별 메인 메뉴 항목 (with subs)
//   commonMenu (Array)             — 사이드바 하단 공통 메뉴
//   collapsed (Boolean)            — 접힘 상태
//
// data: expandedIndex — 현재 펼친 sub-item 의 index (M15 결정 — UIkit uk-nav-parent-icon collapsible 패턴)
//
// events: toggle — 접기 버튼 클릭 시 emit
import formatNumberMixin from './mixins/format-number';

export default {
    name: 'app-sidebar',
    mixins: [formatNumberMixin],
    props: {
        adminContextCard: {
            type: Object,
            default: null,
        },
        // hot-fix #20 안건 13 (2026-05-07): 센터 표시 (page_region_id 기반)
        centerLabel: {
            type: String,
            default: null,
        },
        centerFlag: {
            type: String,
            default: null,
        },
        // 안건 79 (2026-05-14): 회원사 + 전체센터 (page_region_id 없음) 시 국기 대체 아이콘 (material-icons name, 예: 'home' — 서브헤더 writeSubHeaderForMember 와 동일)
        centerIcon: {
            type: String,
            default: null,
        },
        // 안건 77 (2026-05-12): 센터 섹션 클릭 시 진입 URL — 컨텍스트별 종합현황 (회원사/창고)
        centerUrl: {
            type: String,
            default: null,
        },
        routingLabel: {
            type: String,
            default: null,
        },
        mainMenu: {
            type: Array,
            default: () => [],
        },
        commonMenu: {
            type: Array,
            default: () => [],
        },
        collapsed: {
            type: Boolean,
            default: false,
        },
        // 안건 39 (2026-05-11): 강제 collapsed (localStorage 우회 + persist 차단)
        //   상품상세 등 작업 집중 페이지에서 사용자 localStorage 와 무관하게 항상 접힘 진입.
        //   사용자가 페이지 내에서 토글로 펼치는 것은 가능하나, 다른 페이지로 이동 시 그 상태가 저장 안 됨.
        forceCollapsed: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            // active subs 가 있는 첫 main 항목을 자동 펼침
            expandedIndex: this.findInitialExpanded(),
            // hot-fix #4 (2026-05-05): collapsed 자체 state 관리. 외부 (header.vue 햄버거) 와 통신은 window event 로
            // hot-fix #9 (2026-05-05): localStorage 우선 (페이지 이동 유지 — 결정 13). 미저장 시 props collapsed 사용
            // 안건 39 (2026-05-11): forceCollapsed=true 시 localStorage 우회 — 무조건 collapsed
            innerCollapsed: (() => {
                if (this.forceCollapsed) return true;
                try {
                    const saved = window.localStorage.getItem('ref020-sidebar-collapsed');
                    if (saved !== null) return saved === '1';
                } catch (e) { /* localStorage 차단 환경 */ }
                return this.collapsed;
            })(),
        };
    },
    mounted() {
        // hot-fix #4: header.vue 햄버거 클릭 시 dispatch 되는 window event 리스너 등록
        this._sidebarToggleHandler = () => {
            this.innerCollapsed = !this.innerCollapsed;
            this.persistCollapsed();
        };
        window.addEventListener('ref020-sidebar-toggle', this._sidebarToggleHandler);

        // hot-fix #20 안건 6 (2026-05-07): 초기값 dispatch — sidebar-default-collapsed section 으로 강제 collapsed 시 header.vue 의 sidebarCollapsed 동기화. nextTick 으로 다른 컴포넌트 마운트 완료 후 dispatch (header.vue listener 등록 보장)
        this.$nextTick(() => {
            window.dispatchEvent(new CustomEvent('ref020-sidebar-collapsed-changed', {
                detail: { collapsed: this.innerCollapsed },
            }));
        });
    },
    beforeDestroy() {
        window.removeEventListener('ref020-sidebar-toggle', this._sidebarToggleHandler);
    },
    computed: {
        // 안건 91 후속 3 (2026-05-18 사용자 결정): cardDepositClass 폐기 — 예치금 색상 강조 제거.
        //   기존 안건 37 (2026-05-08) 의 plus/minus/zero 분기 → 강조 대상은 미결제만 (인지 부담 감소).
    },
    methods: {
        findInitialExpanded() {
            for (let i = 0; i < this.mainMenu.length; i++) {
                const item = this.mainMenu[i];
                if (item.subs && item.subs.length > 0 && (item.active || item.subs.some((s) => s.active))) {
                    return i;
                }
            }
            return -1;
        },
        toggleExpand(index) {
            this.expandedIndex = this.expandedIndex === index ? -1 : index;
        },
        onToggle() {
            // hot-fix #4: 사이드바 ◀ 클릭 — 자체 state 토글 + 이벤트 통지
            this.innerCollapsed = !this.innerCollapsed;
            this.persistCollapsed();
            this.$emit('toggle');
        },
        // hot-fix #9 (2026-05-05): collapsed 상태 localStorage 저장 (결정 13 — 페이지 이동 유지)
        // hot-fix #20 안건 4 (2026-05-07): 사이드바 collapsed 변경 시 event dispatch — header.vue 가 brand 표시 분기
        // 안건 39 (2026-05-11): forceCollapsed=true 시 localStorage 저장 차단 — 다른 페이지에 영향 없음
        persistCollapsed() {
            if (!this.forceCollapsed) {
                try {
                    window.localStorage.setItem('ref020-sidebar-collapsed', this.innerCollapsed ? '1' : '0');
                } catch (e) { /* localStorage 차단 환경 — silent */ }
            }
            window.dispatchEvent(new CustomEvent('ref020-sidebar-collapsed-changed', {
                detail: { collapsed: this.innerCollapsed },
            }));
        },
        // formatNumber 는 mixin 에서 제공 (hot-fix #10)
    },
};
</script>

<style scoped>
.ref020-sidebar {
    /* hot-fix #20 안건 3 (2026-05-07): full-height drawer 구조 — sticky top:0 + 100vh.
       hot-fix #20 안건 20 (2026-05-08): outer 는 overflow hidden, 스크롤은 inner wrapper(.ref020-sidebar-scroll) 가 담당.
                                          핸들(absolute right:0) 은 outer 안 그대로 → 스크롤 시 핸들 고정 (사용자 결정)
       안건 71 (2026-05-12): 240px → 260px — /admin/billing-items 서브메뉴 "과금세부내역 (운송장별 비용 조회)" 등 긴 명칭 잘림 해소 (사용자 발견) */
    width: 260px;
    box-sizing: border-box;
    background: #f9fafb;
    border-right: 1px solid #e5e7eb;
    position: sticky;
    top: 0;
    height: 100vh;
    overflow: hidden;
    transition: width 0.2s ease;
    flex-shrink: 0;
}
/* hot-fix #20 안건 20 (2026-05-08): inner scroll wrapper — 메뉴 영역만 스크롤.
   width: calc(100% - 16px) 로 핸들 자리(16px) 제외 → scrollbar 가 wrapper 우측 가장자리(= 핸들 좌측)에 위치.
   padding-right 만으로는 scrollbar 가 padding-box 우측(=element 우측, 핸들 영역)에 그려져 핸들과 겹쳐 부적합.

   안건 63 (2026-05-12): padding-bottom = 가로 스크롤바 회피 buffer.
     sticky height: 100vh 가 viewport 전체를 사용하므로, 콘텐츠 가로 overflow 발생 시 가로 스크롤바
     (~15-17px) 영역이 사이드바 마지막 메뉴를 가림. 1.25rem (15px) 로 최소 buffer 만 확보.
     배경/시각 효과 0 — 단순 padding. 별도 div 미사용 (단순화). */
.ref020-sidebar-scroll {
    width: calc(100% - 16px);
    height: 100%;
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 1.25rem;
}
/* hot-fix #20 (2026-05-07): combined selector 로 specificity 보강 (.ref020-sidebar 와 동률 → declaration order 만으로 override 안 됨, scoped CSS data-v 영향). collapsed width 16 (핸들 width 와 동일 → 좌측 여백 0, 사용자 결정) */
.ref020-sidebar.ref020-sidebar-collapsed {
    width: 16px;
    background: #f3f4f6;
}
/* collapsed 시 inner scroll wrapper hide. 핸들은 outer 안 absolute 라 영향 안 받음 */
.ref020-sidebar.ref020-sidebar-collapsed > .ref020-sidebar-scroll {
    display: none;
}

/* 브랜드 (사이드바 좌상) */
.ref020-sidebar-brand {
    display: flex;
    align-items: baseline;
    gap: 0.375rem;
    padding: 0.875rem 1rem;
    text-decoration: none;
    color: #111827;
    border-bottom: 1px solid #e5e7eb;
}
.ref020-sidebar-brand-icon {
    font-style: normal;
    font-size: 1.125rem;
}
.ref020-sidebar-brand-name {
    font-weight: 700;
    font-size: 1.125rem;
}

/* 손잡이 bar (사이드바 안 absolute, 우측 가장자리 전체 세로)
   안건 81 (2026-05-14): bar 약한 볼록 + indicator 음각 강조 (사용자 결정).
   bar = 좌→우 그라데이션 (좌측 어두움, 우측 밝음 + 우측 inset highlight) → 살짝 raised 느낌
   indicator = 진한 회색 + inset shadow (음각) + 흰 글자 → 강한 인지 */
.ref020-sidebar-toggle {
    /* hot-fix #20 안건 3 (2026-05-07): full-height drawer — 사이드바 안 absolute. fixed 폐기 (z-index 충돌 0) */
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    width: 16px;
    background: linear-gradient(to right, #d1d5db, #e5e7eb);
    border: none;
    border-left: 1px solid #b0b3bb;
    /* 안건 81 정정 (2026-05-14): 우측 구분선 + outer cast shadow — 컨텐츠 영역(#fff) 과 명확 분리.
       기존 inset 흰 highlight 는 우측이 컨텐츠 흰색과 동화되는 부작용 → 제거. */
    border-right: 1px solid #9ca3af;
    box-shadow: 2px 0 3px rgba(0, 0, 0, 0.06);
    cursor: pointer;
    padding: 0;
    transition: background 0.15s;
}
.ref020-sidebar-toggle:hover {
    background: linear-gradient(to right, #b0b3bb, #d1d5db);
    box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
}
.ref020-sidebar-toggle-indicator {
    /* hot-fix #20 안건 5 (2026-05-07): 화살표 + 세로 텍스트 stack — viewport 세로 중앙 (사이드바 sticky 100vh → 50% = 50vh)
       안건 81 정정 (2026-05-14): 흰 배경 + 검은 텍스트 + 살짝 raised pill (회색 bar 위에 떠있는 흰 카드).
       사용자 피드백: 음각 진한 회색 → 시선 너무 강함 / 배경 제거 → 너무 안 보임.
       흰 배경 + 검은 텍스트 = 회색 bar 위 자연스러운 강한 contrast. */
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.25rem;
    pointer-events: none;
    /* 안건 81 정정 (2026-05-14): 순백 #fff → bar 회색 그라데이션 (#d1d5db~#e5e7eb) 한 단계 밝은 #f3f4f6.
       너무 흰 배경 → 회색 톤 안에서 자연스러운 밝은 계열로 변경. hover 시 한 단계 더 밝아짐 (#fff). */
    background: #f3f4f6;
    padding: 0.5rem 0.125rem;
    border-radius: 0.25rem;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    transition: background 0.15s, box-shadow 0.15s;
}
.ref020-sidebar-toggle:hover .ref020-sidebar-toggle-indicator {
    background: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.14);
}
.ref020-sidebar-toggle-text {
    /* hot-fix #20 안건 7 (2026-05-07): 영문 OPEN/CLOSE 정자 stack — text-orientation: upright (사용자 결정, 회전 → 정자 변경)
       안건 81 정정 (2026-05-14): 검은 글자 (#1f2937) + weight 600 — 흰 배경 위 강한 contrast */
    writing-mode: vertical-rl;
    text-orientation: upright;
    font-size: 0.75rem;
    font-weight: 600;
    color: #1f2937;
    letter-spacing: 0.05em;
    line-height: 1;
}
.ref020-sidebar-toggle-arrow {
    color: #1f2937;
    font-size: 0.75rem;
    line-height: 1;
}
/* 안건 37 (2026-05-08): 컨텍스트 카드 디자인 개선 — 헤더(닉) + 정보 행(아이콘 + 라벨 + 값) + 예치금·미결제 클릭 링크 */
.ref020-sidebar-admin-card {
    margin: 1rem 0.75rem 0.75rem;
    padding: 0.625rem 0.75rem 0.5rem;
    background: #fff;
    border: 1px solid #e5e7eb;
    border-left: 3px solid #9ca3af;
    border-radius: 0.375rem;
    color: #374151;
}
.ref020-admin-card-header {
    display: flex;
    align-items: center;
    gap: 0.375rem;
    padding-bottom: 0.5rem;
    margin-bottom: 0.375rem;
    border-bottom: 1px solid #f0f0f0;
}
.ref020-admin-card-header i.material-icons {
    font-size: 1.125rem;
    color: #6b7280;
}
.ref020-admin-card-nick {
    font-weight: 600;
    font-size: 1.0833rem;
    color: #111827;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.ref020-admin-card-rows {
    display: flex;
    flex-direction: column;
    gap: 0.125rem;
}
.ref020-admin-card-row {
    display: flex;
    align-items: center;
    gap: 0.375rem;
    padding: 0.25rem 0.375rem;
    font-size: 1rem;
    line-height: 1.4;
    border-radius: 0.25rem;
    color: #4b5563;
    text-decoration: none;
    transition: background-color 0.15s ease;
}
.ref020-admin-card-row i.material-icons {
    font-size: 1rem;
    color: #9ca3af;
    flex-shrink: 0;
}
.ref020-admin-card-label {
    color: #9ca3af;
    font-weight: 500;
    min-width: 3.25rem;
    white-space: nowrap;
    flex-shrink: 0;
}
.ref020-admin-card-value {
    flex: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
/* 클릭 링크 (예치금·미결제) — hover 시 살짝 강조 */
.ref020-admin-card-link {
    cursor: pointer;
}
.ref020-admin-card-link:hover {
    background: #f6f8fa;
}
.ref020-admin-card-link:hover .ref020-admin-card-value {
    color: #111827;
}
/* 안건 91 후속 3 (2026-05-18 사용자 결정): 예치금 색상 분기 폐기.
   강조 대상은 미결제만 — 예치금은 일반 텍스트 (.ref020-admin-card-value 기본 색상). */
/* 미결제 강조 — 빨간 톤 + amber 배경 */
.ref020-admin-card-arrears {
    background: #fff5f5;
    color: #ad1c1c;
    font-weight: 600;
}
.ref020-admin-card-arrears i.material-icons { color: #ef4444; }
.ref020-admin-card-arrears .ref020-admin-card-label { color: #ad1c1c; }
.ref020-admin-card-arrears .ref020-admin-card-value { color: #ad1c1c; }
.ref020-admin-card-arrears.ref020-admin-card-link:hover {
    background: #ffeaea;
}
/* hot-fix #20 안건 13 (2026-05-07): 센터 표시 — 큰 폰트 + 국기. 회원사 카드 아래, 라우팅 라벨 위
   안건 77 (2026-05-12): anchor 변환 시 hover 효과 추가 (클릭 시그널). */
.ref020-sidebar-center {
    display: flex;
    align-items: center;
    gap: 0.625rem;
    padding: 1rem 1rem;
    background: #fff;
    border-top: 1px solid #e5e7eb;
    border-bottom: 1px solid #e5e7eb;
    color: #111827;
    text-decoration: none;
    transition: background-color 0.15s ease;
}
a.ref020-sidebar-center-link:hover {
    background: #f6f8fa;
}
a.ref020-sidebar-center-link:hover .ref020-sidebar-center-label {
    color: #1e40af;
}
.ref020-sidebar-center-flag {
    width: 24px;
    height: auto;
    flex-shrink: 0;
    border: 1px solid #e5e7eb;
    border-radius: 2px;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.04);
}
/* 안건 79 (2026-05-14): 전체센터 시 국기 대체 아이콘 — 국기 24px 와 동등 시각 비중 */
.ref020-sidebar-center-icon {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    font-size: 22px;
    line-height: 24px;
    color: #6b7280;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}
.ref020-sidebar-center-label {
    font-weight: 600;
    font-size: 1.0625rem;
    line-height: 1.25;
    letter-spacing: -0.01em;
    word-break: keep-all;
}
.ref020-sidebar-context-label {
    margin: 0.5rem 0.75rem;
    font-size: 1rem;
    font-weight: 600;
    color: #6b7280;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}
.ref020-sidebar-menu {
    list-style: none;
    padding: 0;
    margin: 0;
}
.ref020-sidebar-menu-item {
    margin: 0;
}
.ref020-sidebar-link {
    /* hot-fix #20 안건 18 (2026-05-08): 가독성 강화 — 관리사이트 효율 중시 (사용자 결정).
       메인 메뉴 시각 비중 ↑ + 행 호흡 ↑ + 텍스트 대비 ↑
       안건 70 (2026-05-12): font-weight 500 → 400 통일. 안건 48·60·61 정책 정합 (12px 본문에서 medium weight 효과 미미 +
       button 의 user-agent normal 우선 적용으로 1차 메뉴 중 leaf/parent 시각 불일치 문제 해소). 가독성 강조는 size·padding·line-height·color 로 유지 */
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.625rem 1rem;
    color: #1f2937;
    text-decoration: none;
    font-size: 1.0625rem;
    font-weight: 400;
    line-height: 1.4;
    border: none;
    background: transparent;
    width: 100%;
    text-align: left;
    cursor: pointer;
}
.ref020-sidebar-link:hover {
    background: #f3f4f6;
}
.ref020-sidebar-menu-item.active > .ref020-sidebar-link {
    background: #dbeafe;
    color: #1e40af;
    font-weight: 500; /* 안건 70: 600 → 500 (active 살짝만 강조, 사이드바 전체 weight 통일 정책) */
}
/* hot-fix #20 안건 24 (2026-05-08): primary 항목 시각 강조 — 배경 노랑 → 아이콘만 색 강조 (사용자 결정 옵션 A).
   다수 항목이 primary 시 "노란 띠" 효과로 메뉴 위계 흐려지는 문제 해소. 아이콘 색만 강조해서 시각 단서 + 정렬 유지.
   색상: emerald-500 (#10b981) — 사이드바 gray 톤 + active blue 와 시각 충돌 없는 보색 계열, 차분 + 채도 적당 (amber-600 칙칙함 정정). */
.ref020-sidebar-menu-item.primary > .ref020-sidebar-link i.material-icons {
    color: #10b981;
}
.ref020-sidebar-link i.material-icons {
    /* hot-fix #20 안건 18 (2026-05-08): 메뉴 텍스트 1.0625rem 와 광학 균형 */
    font-size: 1.25rem;
}
.ref020-sidebar-link img {
    width: 1rem;
    height: auto;
}
.ref020-sidebar-link-name {
    /* hot-fix #20 (2026-05-07): 메뉴명 길어지면 ellipsis + 호버 툴팁 (a/button 의 title 속성). flex item min-width auto 우회 필수 (사용자 결정) */
    flex-grow: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
/* 안건 59 (2026-05-12): 서브메뉴 토글 화살표 — Material Icons 로 교체.
   유니코드 ▾/▸ 는 폰트 의존성 + 가독성 한계 (12px 본문에서 흐릿) → Material 으로 시각 명확화.
   크기: 1.375rem (16.5px) — 메뉴 아이콘(1.25rem=15px) 보다 약간 키워 토글임을 명시.
   색상: #374151 — 메뉴 텍스트(#1f2937) 와 동일 톤대로 또렷. */
.ref020-sidebar-arrow {
    font-size: 1.375rem;
    color: #374151;
    line-height: 1;
    flex-shrink: 0;
    transition: color 0.15s ease;
}
.ref020-sidebar-parent:hover .ref020-sidebar-arrow {
    color: #111827;
}
.ref020-sidebar-menu-item.expanded > .ref020-sidebar-parent .ref020-sidebar-arrow {
    color: #1e40af;
}
.ref020-sidebar-badge {
    background: #ef4444;
    color: #fff;
    border-radius: 9999px;
    padding: 0 0.5rem;
    font-size: 1rem;
    line-height: 1.5;
}
/* 안건 60 (2026-05-12): 서브메뉴 가독성 강화 — 텍스트 메인과 동등.
   안건 62 (2026-05-12): indent 2rem → 0 (사용자 결정 "너무 깊게 들어간 느낌"). 계층 단서는 bullet prefix + 배경 톤 + 좌측 보더 로 유지. */
.ref020-sidebar-submenu {
    list-style: none;
    padding: 0;
    margin: 0;
    background: #f9fafb;
    border-left: 2px solid #e5e7eb;
}
/* 안건 61 (2026-05-12): 서브메뉴 — bold 제거 (weight 400).
   안건 62 (2026-05-12): chevron_right (방향성) → bullet • (중성 marker). indent 깊이 감소도 같이 적용. */
.ref020-sidebar-sublink {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.5rem;
    padding: 0.625rem 1rem;
    color: #1f2937;
    text-decoration: none;
    font-size: 1.0625rem;
    font-weight: 400;
    line-height: 1.4;
}
.ref020-sidebar-sub-prefix {
    color: #9ca3af;
    font-size: 1rem;
    line-height: 1;
    flex-shrink: 0;
    width: 0.75rem;
    text-align: center;
    user-select: none;
    transition: color 0.15s ease;
}
.ref020-sidebar-sublink:hover {
    background: #f3f4f6;
}
.ref020-sidebar-sublink:hover .ref020-sidebar-sub-prefix {
    color: #6b7280;
}
.ref020-sidebar-submenu-item.active > .ref020-sidebar-sublink {
    color: #1e40af;
    font-weight: 500;
    background: #dbeafe;
}
.ref020-sidebar-submenu-item.active > .ref020-sidebar-sublink .ref020-sidebar-sub-prefix {
    color: #1e40af;
}
.ref020-sidebar-sublink .ref020-sidebar-link-name {
    flex-grow: 1;
}
.ref020-sidebar-divider {
    border: 0;
    border-top: 1px solid #e5e7eb;
    margin: 0.5rem 0;
}
.ref020-sidebar-common .ref020-sidebar-link {
    color: #6b7280;
}

/* 안건 63 (2026-05-12): bottom-spacer div 폐기 — .ref020-sidebar-scroll 의 padding-bottom 으로 단순화. */
</style>
